
import axios from 'axios';
import types from './mutations-types';

const actions = {
  async setList({ commit }, obj) {
    const list = await axios.get(
      `${process.env.API_ROOT}/templates/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    commit(types.SET_LIST, list.data);
  },

  async setTemplate({ commit }, obj) {
    const template = await axios.get(
      `${process.env.API_ROOT}/template/${obj.id}/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    commit(types.SET_TEMPLATE, template.data);
    return template.data;
  },

  async storeTemplate({ commit }, obj) {
    const item = await axios.post(
      `${process.env.API_ROOT}/template/`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    return item;
  },

  async updateTemplate({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/template/${obj.id}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    // commit(types.SET_TEMPLATE, template.data);
  },

  async delete({ commit }, obj) {
    await axios.delete(`${process.env.API_ROOT}/template/${obj.id}`, {
      headers: {
        'x-access-token': obj.token,
      },
    });
  },

  async setScaleColors({ commit }, value) {
    commit(types.SET_TEMPLATE, {
      scale: value,
    });
  },
  async setBorderColors({ commit }, value) {
    commit(types.SET_TEMPLATE, {
      border: value,
    });
  },
  async setGradeColors({ commit }, value) {
    commit(types.SET_TEMPLATE, {
      grade: value,
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/templates/actions.js